export default __webpack_public_path__ + "media/images/react_icons/calendar-6e6304ee6718853de1eb1c8d50cef6a0.svg";